import { render } from "./NeuralPlinko.vue?vue&type=template&id=cc845bae"
import script from "./NeuralPlinko.vue?vue&type=script&lang=js"
export * from "./NeuralPlinko.vue?vue&type=script&lang=js"

import "./NeuralPlinko.vue?vue&type=style&index=0&id=cc845bae&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__